// Libellés FR des pages refonte, centralisés en UN endroit (titres, en-têtes de
// colonnes, messages d'état). NE contient PAS les libellés de statut/contrat :
// ceux-là restent dans le contrat partagé (appointmentLifecycle.ts). Ne touche
// pas au LanguageContext existant — ceci ne couvre que le module refonte.

export const REFONTE_STRINGS = {
  common: {
    loading: 'Chargement…',
    readOnly: 'lecture seule',
  },
  sdrDay: {
    title: 'Ma journée',
    listHeader: 'RDV — statuer & faire avancer',
    journalHeader: 'Journal du RDV',
    journalEmpty: 'Clique « journal » sur un RDV pour voir sa preuve horodatée.',
    empty: 'Aucun RDV.',
    enterCycle: 'Entrer dans le cycle',
  },
  health: {
    title: 'Santé clients',
    empty: 'Aucun client à afficher.',
    colPrice: 'Prix mensuel',
    colEnd: 'Échéance',
    scoreNote: 'score binaire v1 (aucun algo)',
  },
  kanban: {
    title: 'Kanban équipe',
    subtitle: 'regroupés par étape du cycle de vie',
    columnEmpty: 'Aucun RDV.',
    colAStatuer: 'À statuer',
    colEffectues: 'Effectués',
    colQualifies: 'Qualifiés',
    colFacturation: 'Facturation',
  },
  portal: {
    title: 'Mon espace',
    subtitle: 'Registre de vos RDV et compteur à facturer',
    counterLabel: 'RDV à facturer',
    counterHint: "Comptés dès qu'un RDV est validé (aucune contestation en cours).",
    registerHeader: 'Registre des RDV',
    empty: 'Aucun RDV pour le moment.',
  },
  bp: {
    title: 'Business plan · la machine',
    subtitle: 'Agrégats temps réel',
    tileBillable: 'RDV à facturer',
    tileHeld: 'RDV effectués',
    tileNoShow: 'No-show',
    tileRevenue: 'CA variable estimé',
    tileRevenueHint: 'Prix à brancher (calibrage)',
    distHeader: 'Répartition par statut',
    distEmpty: 'Aucun RDV dans le cycle.',
    mixHeader: 'Mix de contrats',
    revenueNote:
      'CA = placeholder : brancher le prix unitaire du calibrage (fixe + variable) avant usage en closing.',
  },
} as const;
